import { Tooltip, Box, IconButton } from "@mui/material";
import { useState } from "react";
import PropTypes from "prop-types";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteOrderModal from "./DeleteOrderModal";

DeleteOrderModalButton.propTypes = {
  disabled: PropTypes.bool,
  content: PropTypes.node,
  tooltip: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
  ]),
  rowId: PropTypes.number,
  disableRipple: PropTypes.bool,
  action: PropTypes.func,
}
export default function DeleteOrderModalButton({ disabled = false, content, tooltip, rowId, action, disableRipple}) {
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleOpenConfirm = (e) => {
    e.preventDefault();
    e.confirmDialog = true;
    setOpenConfirm(true);
    e.stopPropagation();
  };

  return <>
    <Tooltip arrow title={tooltip}>
      <Box component="span">
        <IconButton
          color={'error'}
          onClick={handleOpenConfirm}
          id="action-button"
          className="action-button"
          disabled={disabled}
          disableRipple={disableRipple}
          sx={disableRipple ? { p: 0 } : {}}
        >
          <DeleteOutlineIcon />
        </IconButton>
      </Box>
    </Tooltip>
    <DeleteOrderModal
      content={content}
      action={action}
      rowId={rowId}
      openConfirm={openConfirm}
      setOpenConfirm={setOpenConfirm}
    />
  </>
}